import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { login as loginService } from '../services/authService';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const rol = new URLSearchParams(location.search).get('rol');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const { token } = await loginService(email, password);
      const payload = JSON.parse(atob(token.split('.')[1]));
      const { id, email: userEmail, rol: userRol } = payload.user;

      login({ id, email: userEmail, rol: userRol }, token);

      if (userRol === 'entrenador') navigate('/entrenador');
      else navigate('/usuario');
    } catch (err: any) {
      setError('❌ Email o contraseña incorrectos');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4 text-center">🔐 Iniciar sesión</h2>
        {rol && <p className="text-sm text-center text-gray-500 mb-4">Accediendo como <strong>{rol}</strong></p>}
        {error && <p className="text-red-600 text-center mb-2">{error}</p>}
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border rounded px-3 py-2"
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full border rounded px-3 py-2"
          />
          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded font-semibold"
          >
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
